module.exports = __webpack_public_path__ + "static/media/sombra-lateral.49ce7b71.svg";